import AppLayout from '@/layouts/AppLayout.vue';
import AnonymousLayout from '@/layouts/AnonymousLayout.vue';
import { TopbarTypeEnum, PATIENT_ONBOARDING_STATUS } from '@/helpers/enums';

const routes = [
  {
    path: '/savanne',
    alias: ['/'],
    component: AppLayout,
    meta: { requiresAuth: true, allowedOnboardingStatuses: [PATIENT_ONBOARDING_STATUS.ONBOARDING, PATIENT_ONBOARDING_STATUS.ONBOARDED] },
    children: [
      {
        path: '',
        name: 'navigator',
        component: () => import('@/views/navigator/NavigatorView.vue'),
      },
    ],
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: AnonymousLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'welcome',
        component: () => import('@/views/onboarding/WelcomeView.vue'),
        meta: { allowedOnboardingStatuses: [PATIENT_ONBOARDING_STATUS.NOT_YET] },
      },
      {
        path: 'terms-and-conditions',
        name: 'terms-conditions',
        component: () => import('@/views/onboarding/TermAndConditionView.vue'),
        meta: { allowedOnboardingStatuses: [PATIENT_ONBOARDING_STATUS.NOT_YET] },
      },
      {
        path: 'care-plan-group-selection',
        name: 'disease',
        component: () => import('@/views/onboarding/CarePlanGroupSelectionView.vue'),
        meta: { allowedOnboardingStatuses: [PATIENT_ONBOARDING_STATUS.NOT_YET] },
      },
      {
        path: 'care-plan-selection/:id',
        name: 'diagnosis',
        component: () => import('@/views/onboarding/CarePlanSelectionView.vue'),
        meta: { allowedOnboardingStatuses: [PATIENT_ONBOARDING_STATUS.NOT_YET] },
      },
      {
        path: 'active-treatment',
        name: 'treatment',
        component: () => import('@/views/onboarding/ActiveTreatmentView.vue'),
      },
      {
        path: 'active-treatment/:treatmentKey',
        name: 'oncology flow',
        component: () => import('@/views/onboarding/TreatmentSelectionView.vue'),
      },
      {
        path: 'pil/:treatmentKey',
        name: 'enter pil code',
        component: () => import('@/views/onboarding/EnterPILCodeView.vue'),
      },
      {
        path: 'finish/:treatmentKey',
        name: 'onboarding finish',
        component: () => import('@/views/onboarding/StartDateSelection.vue'),
      },
    ]
  },
  {
    path: '/article',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: ':contentId',
        name: 'article-content-detail',
        component: () => import('@/views/article/ContentDetailView.vue'),
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      },
    ],
  },
  {
    path: '/treatment',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: ':treatmentId/chemotherapy',
        name: 'chemotherapy-treatment',
        component: () => import('@/views/treatment/ChemotherapyTreatmentView.vue'),
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      }
    ],
  },
  {
    path: '/side-effects',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: ':treatmentId',
        name: 'side-effects',
        component: () => import('@/views/side-effect/SideEffectListView.vue'),
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      },
      {
        path: 'detail/:mainUnique',
        name: 'side-effects-detail',
        component: () => import('@/views/side-effect/SideEffectDetailView.vue'),
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      },
    ]
  },
  {
    path: '/vigilant',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'tracker-home',
        component: () => import('@/views/tracker/TrackerHomeView.vue'),
      },
      {
        path: 'symptom-selection',
        name: 'symptom-selection',
        component: () => import('@/views/tracker/SymptomSelectionView.vue'),
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      },
      {
        path: 'symptom-selection/:symptomId/severity-selection',
        name: 'record-symptom',
        component: () => import('@/views/tracker/SymptomSeveritySelectionView.vue'),
        props: true,
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      },
      {
        path: 'symptom-selection/:symptomId/assessment-generation',
        name: 'assessment-generation',
        component: () => import('@/views/tracker/AssessmentGeneratedView.vue'),
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      },
      {
        path: 'expected-symptoms',
        name: 'expected-symptoms',
        component: () => import('@/views/tracker/ExpectedSymptomsView.vue'),
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      },
    ],
  },
  {
    path: '/haven',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'medication-home',
        component: () => import('@/views/medication/MedicationHomeView.vue'),
      },
      {
        path: 'my-medications/:medicationId/detail',
        name: 'medication-detail',
        component: () => import('@/views/medication/MedicationDetailView.vue'),
        props: true,
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      },
      {
        path: 'my-intake-events',
        name: 'medication-intake-events',
        component: () => import('@/views/medication/MedicationIntakeEventView.vue'),
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      },
      {
        path: 'my-intake-events/detail',
        name: 'medication-reminder-detail',
        component: () => import('@/views/medication/MedicationIntakeEventDetailView.vue'),
        props: true,
        meta: { topbarType: TopbarTypeEnum.NAVIGATION },
      }
    ],
  },
  {
    path: '/auth/patient-selection',
    name: 'patient-selection',
    component: () => import('@/views/auth/PatientSelectionView.vue'),
  },
  {
    path: '/auth/authorize/:patientMainUnique',
    name: 'authorize-patient',
    component: () => import('@/views/auth/AuthorizePatientView.vue'),
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('@/views/NotFound404View.vue'),
  },
];

export default routes;
